<template>
  <svg
    v-if="iconName == 'telegram'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_3635)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="url(#paint0_linear_1_3635)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.43189 11.8733C8.93014 10.3492 11.2628 9.3444 12.43 8.85893C15.7626 7.47282 16.455 7.23203 16.9064 7.22408C17.0056 7.22234 17.2276 7.24694 17.3714 7.3636C17.4928 7.46211 17.5262 7.59518 17.5422 7.68857C17.5581 7.78197 17.578 7.99473 17.5622 8.16098C17.3816 10.0585 16.6002 14.6632 16.2027 16.7884C16.0345 17.6876 15.7032 17.9891 15.3826 18.0186C14.6857 18.0828 14.1566 17.5581 13.4816 17.1157C12.4255 16.4234 11.8288 15.9924 10.8036 15.3168C9.61884 14.536 10.3869 14.1069 11.0621 13.4056C11.2388 13.2221 14.3092 10.4294 14.3686 10.176C14.376 10.1443 14.3829 10.0262 14.3128 9.96385C14.2426 9.90148 14.139 9.92281 14.0643 9.93977C13.9584 9.96381 12.2712 11.079 9.00264 13.2853C8.52373 13.6142 8.08994 13.7744 7.70129 13.766C7.27283 13.7568 6.44864 13.5238 5.83594 13.3246C5.08444 13.0803 4.48716 12.9512 4.53917 12.5363C4.56626 12.3202 4.86383 12.0992 5.43189 11.8733Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_3635"
        x1="1200"
        y1="0"
        x2="1200"
        y2="2382.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2AABEE" />
        <stop offset="1" stop-color="#229ED9" />
      </linearGradient>
      <clipPath id="clip0_1_3635">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <!-- <svg
    v-else-if="iconName == 'email'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18.1865 15.0693H16.7305C16.252 15.6755 15.6208 16.1289 14.8369 16.4297C14.0531 16.735 13.1165 16.8877 12.0273 16.8877C10.8971 16.8877 9.89225 16.7054 9.0127 16.3408C8.1377 15.9808 7.45638 15.4066 6.96875 14.6182C6.48568 13.8298 6.24414 12.9548 6.24414 11.9932C6.24414 11.0042 6.46061 10.054 6.89355 9.14258C7.33105 8.22656 7.97819 7.5179 8.83496 7.0166C9.69629 6.51074 10.7445 6.25781 11.9795 6.25781C13.4333 6.25781 14.5658 6.63607 15.377 7.39258C16.1882 8.14453 16.5938 9.08105 16.5938 10.2021C16.5938 10.8265 16.4502 11.4303 16.1631 12.0137C15.876 12.597 15.5 13.0618 15.0352 13.4082C14.6888 13.6725 14.4062 13.8047 14.1875 13.8047C14.1146 13.8047 14.0508 13.7773 13.9961 13.7227C13.946 13.6634 13.9209 13.5768 13.9209 13.4629C13.9209 13.3717 13.9528 13.1712 14.0166 12.8613L15.0488 7.95996H13.2441L13.0732 8.71875C12.6859 8.09896 12.0866 7.78906 11.2754 7.78906C10.1361 7.78906 9.20182 8.32682 8.47266 9.40234C7.87109 10.2865 7.57031 11.264 7.57031 12.335C7.57031 13.2008 7.81869 13.8958 8.31543 14.4199C8.81673 14.9395 9.44564 15.1992 10.2021 15.1992C10.904 15.1992 11.5238 14.9395 12.0615 14.4199C12.1253 14.6751 12.2529 14.8688 12.4443 15.001C12.6357 15.1331 12.9206 15.1992 13.2988 15.1992C14.7025 15.1992 15.8532 14.6068 16.751 13.4219C17.4665 12.4831 17.8242 11.4326 17.8242 10.2705C17.8242 9.29525 17.5872 8.39746 17.1133 7.57715C16.6439 6.75228 15.9626 6.11654 15.0693 5.66992C14.1761 5.22331 13.1553 5 12.0068 5C10.6533 5 9.4502 5.27799 8.39746 5.83398C7.34473 6.38542 6.5153 7.21484 5.90918 8.32227C5.30306 9.42513 5 10.6169 5 11.8975C5 13.0641 5.2666 14.1442 5.7998 15.1377C6.33301 16.1266 7.14648 16.874 8.24023 17.3799C9.33398 17.8903 10.6328 18.1455 12.1367 18.1455C13.6908 18.1455 15.0078 17.8447 16.0879 17.2432C17.0312 16.7191 17.7308 15.9945 18.1865 15.0693ZM9.68945 13.5381C9.45703 13.2646 9.34082 12.8385 9.34082 12.2598C9.34082 11.8268 9.42513 11.3301 9.59375 10.7695C9.76237 10.209 10.013 9.77832 10.3457 9.47754C10.6784 9.1722 11.0407 9.01953 11.4326 9.01953C11.7972 9.01953 12.098 9.15853 12.335 9.43652C12.5765 9.70996 12.6973 10.1042 12.6973 10.6191C12.6973 11.0794 12.6084 11.5762 12.4307 12.1094C12.2575 12.6426 12.0501 13.0482 11.8086 13.3262C11.64 13.5221 11.4691 13.6657 11.2959 13.7568C11.068 13.8844 10.8242 13.9482 10.5645 13.9482C10.2181 13.9482 9.92643 13.8115 9.68945 13.5381Z"
      fill="#DDC702"
    />
  </svg> -->

  <svg
    v-else-if="iconName == 'phone'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_3636)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.3467 3.57737C18.1286 1.35659 15.1786 0.133184 12.0358 0.131866C5.55997 0.131866 0.289637 5.40193 0.287002 11.8796C0.286212 13.9502 0.827049 15.9713 1.85525 17.7532L0.188477 23.8412L6.41667 22.2074C8.1327 23.1434 10.0647 23.6368 12.031 23.6373H12.0358C12.0355 23.6373 12.036 23.6373 12.0358 23.6373C18.5108 23.6373 23.7817 18.3667 23.7843 11.8888C23.7856 8.7497 22.5649 5.79814 20.3467 3.57737ZM7.26467 12.3072C7.11794 12.1112 6.06603 10.7155 6.06603 9.27051C6.06603 7.82556 6.82447 7.11533 7.09344 6.8216C7.36241 6.52786 7.68064 6.45437 7.87637 6.45437C8.07211 6.45437 8.2681 6.45621 8.43908 6.46464C8.61927 6.47386 8.86137 6.39615 9.09951 6.9686C9.34425 7.55632 9.93119 9.00154 10.0047 9.14828C10.0782 9.29528 10.1269 9.46651 10.0292 9.66251C9.93145 9.85824 9.88245 9.98074 9.73571 10.1522C9.58898 10.3237 9.42749 10.535 9.29525 10.6665C9.14825 10.8129 8.99519 10.9718 9.16643 11.2655C9.33766 11.5595 9.92671 12.5208 10.7995 13.2993C11.9207 14.2995 12.8667 14.6093 13.1601 14.7563C13.4536 14.9033 13.6248 14.8788 13.7961 14.6828C13.9673 14.4868 14.53 13.8256 14.7257 13.5319C14.9215 13.2381 15.1172 13.2871 15.3862 13.3849C15.6554 13.4829 17.0985 14.1931 17.392 14.3398C17.6855 14.4868 17.8812 14.5603 17.9547 14.6828C18.0282 14.8053 18.0282 15.3931 17.7835 16.0788C17.5387 16.7645 16.3659 17.3904 15.8019 17.4745C15.2961 17.5501 14.6562 17.5817 13.9528 17.358C13.5266 17.2229 12.9797 17.0422 12.2792 16.7398C9.33476 15.4681 7.41167 12.5032 7.26467 12.3072Z"
        fill="#00B336"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3636">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-else-if="iconName == 'facebook'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.5 10C10.5 7.5 11.5 6.0001 15 6V8C13 8 13 9 13 10H15.5L15 12H13V18H10.5V12H9V10H10.5Z"
      fill="#0A569B"
    />
  </svg>

  <svg
    v-else-if="iconName == 'linkedin'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM6.79938 9.82617V17.0859H8.72028V9.82617H6.79938ZM8.70062 7.91406C8.70062 8.46635 8.25291 8.91406 7.70062 8.91406C7.14834 8.91406 6.70062 8.46635 6.70062 7.91406C6.70062 7.36178 7.14834 6.91406 7.70062 6.91406C8.25291 6.91406 8.70062 7.36178 8.70062 7.91406ZM15.3785 17.0859H17.2994V12.5742C17.2994 12.0137 17.2629 11.583 17.19 11.2822C17.1216 10.9814 16.9963 10.7126 16.814 10.4756C16.6363 10.2386 16.372 10.0449 16.0211 9.89453C15.6701 9.73958 15.2828 9.66211 14.8589 9.66211C13.8974 9.66211 13.0998 10.0723 12.4664 10.8926V9.82617H10.6822V17.0859H12.6031V13.7979C12.6031 12.9867 12.6509 12.4307 12.7466 12.1299C12.8469 11.8291 13.0292 11.5876 13.2935 11.4053C13.5578 11.223 13.8563 11.1318 14.189 11.1318C14.4488 11.1318 14.6698 11.1956 14.8521 11.3232C15.039 11.4508 15.1734 11.6309 15.2554 11.8633C15.3375 12.0911 15.3785 12.597 15.3785 13.3809V17.0859Z"
      fill="#0075DB"
    />
  </svg>

  <svg
    v-else-if="iconName == 'site'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.53271 11.5263H3.96107C4.17307 7.87156 6.82248 4.8708 10.3079 4.12545C9.8849 4.52343 9.45577 5.02286 9.06507 5.65119C8.23731 6.98239 7.60035 8.86282 7.53271 11.5263Z"
      fill="#57A2E8"
    />
    <path
      d="M9.86959 6.15144C10.3921 5.31107 10.9896 4.73685 11.5263 4.33991V11.5263H8.48039C8.54753 9.01942 9.14576 7.31551 9.86959 6.15144Z"
      fill="#57A2E8"
    />
    <path
      d="M8.48039 12.4737H11.5263V19.6601C10.9896 19.2631 10.3921 18.6889 9.86959 17.8486C9.14576 16.6845 8.54753 14.9806 8.48039 12.4737Z"
      fill="#57A2E8"
    />
    <path
      d="M9.06507 18.3488C9.45577 18.9771 9.88491 19.4766 10.3079 19.8745C6.82248 19.1292 4.17307 16.1284 3.96107 12.4737H7.53271C7.60035 15.1372 8.23731 17.0176 9.06507 18.3488Z"
      fill="#57A2E8"
    />
    <path
      d="M20.0389 12.4737C19.8269 16.1284 17.1775 19.1292 13.6921 19.8745C14.1151 19.4766 14.5442 18.9771 14.9349 18.3488C15.7627 17.0176 16.3997 15.1372 16.4673 12.4737H20.0389Z"
      fill="#57A2E8"
    />
    <path
      d="M12.4737 12.4737H15.5196C15.4525 14.9806 14.8542 16.6845 14.1304 17.8486C13.6079 18.6889 13.0104 19.2631 12.4737 19.6601V12.4737Z"
      fill="#57A2E8"
    />
    <path
      d="M12.4737 11.5263H15.5196C15.4525 9.01942 14.8542 7.31551 14.1304 6.15144C13.6079 5.31107 13.0104 4.73685 12.4737 4.33991V11.5263Z"
      fill="#57A2E8"
    />
    <path
      d="M20.0389 11.5263H16.4673C16.3997 8.86282 15.7627 6.98239 14.9349 5.65119C14.5442 5.02286 14.1151 4.52343 13.6921 4.12545C17.1775 4.8708 19.8269 7.87156 20.0389 11.5263Z"
      fill="#57A2E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
      fill="#57A2E8"
    />
  </svg>

  <svg
    v-else-if="iconName == 'habr' || iconName == 'moi_krug'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.6069 10.0005V5H8V18.6006H10.6069V13.665C10.6069 12.8363 10.6842 12.2116 10.8389 11.791C10.9997 11.3643 11.2502 11.0457 11.5903 10.8354C11.9305 10.6252 12.3171 10.52 12.75 10.52C13.1273 10.52 13.4396 10.6035 13.687 10.7705C13.9406 10.9313 14.1169 11.1509 14.2158 11.4292C14.3148 11.7075 14.3643 12.3631 14.3643 13.396V18.6006H16.9712V12.8208C16.9712 11.9364 16.9248 11.2839 16.832 10.8633C16.7454 10.4427 16.5785 10.0592 16.3311 9.71289C16.0898 9.36654 15.728 9.08203 15.2456 8.85938C14.7632 8.63672 14.222 8.52539 13.6221 8.52539C12.4531 8.52539 11.4481 9.01709 10.6069 10.0005Z"
      fill="#87BBCC"
    />
  </svg>

  <svg
    v-else-if="iconName == 'skype'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.9127 13.2584C20.9703 12.8472 21 12.4271 21 12C21 7.02944 16.9706 3 12 3C10.3239 3 8.75488 3.45816 7.41124 4.25606C6.97238 4.09056 6.49677 4 6 4C3.79086 4 2 5.79086 2 8C2 9.06104 2.41312 10.0256 3.08728 10.7416C3.02975 11.1528 3 11.5729 3 12C3 16.9706 7.02944 21 12 21C13.6761 21 15.2451 20.5418 16.5888 19.7439C17.0276 19.9094 17.5032 20 18 20C20.2091 20 22 18.2091 22 16C22 14.939 21.5869 13.9744 20.9127 13.2584ZM12 5.75C10.2523 5.75 9.00588 6.27998 8.25762 7.18524C7.54484 8.04758 7.43345 9.08216 7.60844 9.78214C7.76327 10.4014 8.03256 11.1229 8.79869 11.7173C9.48546 12.2502 10.4539 12.586 11.7549 12.8462C12.9706 13.0894 13.6975 13.3868 14.0644 13.6993C14.2213 13.833 14.2859 13.9474 14.3165 14.0515C14.3493 14.1629 14.3714 14.3604 14.2873 14.6968C14.2278 14.9347 14.0424 15.1559 13.5582 15.3272C13.0697 15.4999 12.4862 15.5333 12.1141 15.5035C11.8053 15.4717 11.2564 15.3612 10.7142 15.1376C10.1494 14.9046 9.74332 14.6115 9.54006 14.3066C9.15712 13.7322 8.38104 13.577 7.80662 13.9599C7.23221 14.3429 7.077 15.119 7.45994 15.6934C8.05668 16.5885 8.98391 17.1282 9.76081 17.4487C10.5547 17.7762 11.35 17.9399 11.8764 17.9922L11.8955 17.994C12.5238 18.0467 13.4845 18.005 14.3918 17.6841C15.3077 17.3602 16.3722 16.6653 16.7127 15.3032C16.8786 14.6396 16.9007 13.9771 16.7147 13.3455C16.5266 12.7066 16.1537 12.1949 15.6856 11.7962C14.8025 11.044 13.5294 10.6516 12.2451 10.3948C11.0461 10.1549 10.5476 9.91004 10.3312 9.74213C10.1941 9.6358 10.124 9.53654 10.0338 9.1758C10.0338 9.1758 10.0342 9.17562 10.0342 9.1712C10.0344 9.13885 10.0353 8.95855 10.1846 8.77799C10.3187 8.61568 10.7477 8.25 12 8.25C12.7253 8.25 13.3985 8.46318 13.9227 8.74589C14.5012 9.05781 14.7171 9.35034 14.7171 9.35034C15.0258 9.96781 15.7766 10.2181 16.3941 9.90936C17.0116 9.60062 17.2619 8.84978 16.9531 8.23231C16.6198 7.56564 15.8828 6.96251 15.1093 6.54543C14.2817 6.09915 13.204 5.75 12 5.75Z"
      fill="#57A2E8"
    />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      default: 'Icon'
    }
  }
};
</script>
